import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const ErrorUnexpected: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.5 70V36h4v34h-4zM60.5 84a4 4 0 100-8 4 4 0 000 8z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.5 7.687l45 26.162v52.302l-45 26.162-45-26.162V33.849l45-26.162zm-41 28.464v47.698l41 23.838 41-23.838V36.151l-41-23.838-41 23.838z"
        fill={color}
      />
    </svg>
  );
};

export default ErrorUnexpected;
